import { ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";
import { isPathEnabled } from "@/auth/modules";

/**
 * 路由级模块开关。包在受保护页面外层；模块未启用时跳回首页。
 *
 * 用法：在 main.tsx 子路由 element 外包一层即可，例：
 *   { path: "ml/experiments", element: <ModuleGuard><MlExperimentsPage /></ModuleGuard> }
 *
 * 没必要给 core/settings 包，本来就 forced。
 */
export function ModuleGuard({ children }: { children: ReactNode }) {
  const { me, status } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  if (status !== "authed") return <>{children}</>; // AuthGuard 早就拦了，这里 noop
  if (isPathEnabled(me?.preferences, location.pathname)) {
    return <>{children}</>;
  }
  return (
    <section className="mx-auto max-w-lg rounded-xl border bg-white p-6 text-center shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
      <h1 className="text-lg font-semibold">该功能模块未启用</h1>
      <p className="mt-2 text-sm text-zinc-500">
        当前页面已被功能模块设置关闭，因此无法打开。你可以到模块设置中重新启用它。
      </p>
      <div className="mt-5 flex justify-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="rounded border px-3 py-1.5 text-sm dark:border-zinc-700"
        >
          返回上一页
        </button>
        <Link
          to="/settings/modules"
          className="rounded bg-zinc-900 px-3 py-1.5 text-sm text-white dark:bg-white dark:text-zinc-900"
        >
          打开模块设置
        </Link>
      </div>
    </section>
  );
}
